module.exports = __webpack_public_path__ + "privatesAsset.05e3fe6a4bfe8cbb7c85547949a96b9d.png";